// src/utils/locationUtils.js

export const CANONICAL_LOCATIONS = [
  "TECNOBOGA - AVENIDA DEL VALLE NORTE #765 - HUECHURABA",
  "VICSA - AVENIDA DEL VALLE NORTE #787 PISO 5 – HUECHURABA",
  "B2B - AVENIDA DEL VALLE NORTE #787 PISO 6 Of. 604/602 - HUECHURABA",
  "B2B- TB- VICSA  - PUERTO SANTIAGO #259 - PUDAHUEL",
  "BUNZL - DPS - AVENIDA DEL VALLE NORTE #841 PISO 5 – HUECHURABA",
  "B2B TIENDA PANAMERICANA - CONCHALÍ",
  "B2B TIENDA LA FABRICA - SAN JOAQUIN",
  "B2B TIENDA VESPUCIO - CONCHALI",
  "B2B TIENDA MAIPU - MAIPÚ",
  "B2B TIENDA PUDAHUEL - PUDAHUEL",
  "B2B TIENDA PUERTO MONTT - PUERTO MONTT",
  "Argentina",
  "Uruguay",
  "Antofagasta",
  "Concepción",
  "Iquique",
  "La Serena",
  "Pucón",
  "Temuco"
];

/**
 * Normaliza y da formato limpio a cualquier string de ubicación proveniente de la BD o entradas de usuario.
 * @param {string} loc
 * @returns {string} Ubicación normalizada según el estándar de la plataforma.
 */
export function formatUbicacion(loc) {
  if (!loc || typeof loc !== 'string') return loc || '';
  const clean = loc.trim();
  if (!clean) return '';

  // Si ya es exactamente una ubicación oficial, devolver tal cual
  if (CANONICAL_LOCATIONS.includes(clean)) return clean;

  const lower = clean.toLowerCase();

  // Mapeo por patrones conocidos
  // Bunzl: nueva dirección. Los registros antiguos de DPS / Camino Coquimbo (Colina) se muestran con ella.
  if ((lower.includes('841') && lower.includes('valle')) || lower.includes('coquimbo') || lower.includes('colina') || lower.includes('dps')) {
    return "BUNZL - DPS - AVENIDA DEL VALLE NORTE #841 PISO 5 – HUECHURABA";
  }
  if (lower.includes('765') || lower.includes('tecnoboga')) {
    return "TECNOBOGA - AVENIDA DEL VALLE NORTE #765 - HUECHURABA";
  }
  if (lower.includes('787') && (lower.includes('604') || lower.includes('602') || lower.includes('piso 6'))) {
    return "B2B - AVENIDA DEL VALLE NORTE #787 PISO 6 Of. 604/602 - HUECHURABA";
  }
  if (lower.includes('787') || (lower.includes('valle') && lower.includes('vicsa'))) {
    return "VICSA - AVENIDA DEL VALLE NORTE #787 PISO 5 – HUECHURABA";
  }
  if (lower.includes('panamericana') || lower.includes('5151')) {
    return "B2B TIENDA PANAMERICANA - CONCHALÍ";
  }
  if (lower.includes('tienda') && lower.includes('pudahuel')) return "B2B TIENDA PUDAHUEL - PUDAHUEL";
  if (lower.includes('tienda') && (lower.includes('maipu') || lower.includes('maipú'))) return "B2B TIENDA MAIPU - MAIPÚ";
  if (lower.includes('puerto montt')) return "B2B TIENDA PUERTO MONTT - PUERTO MONTT";
  if (lower.includes('puerto santiago') || lower.includes('259') || lower.includes('pudahuel')) {
    return "B2B- TB- VICSA  - PUERTO SANTIAGO #259 - PUDAHUEL";
  }
  if (lower.includes('fabrica') || lower.includes('fábrica') || lower.includes('san joaquin') || lower.includes('valdovinos')) {
    return "B2B TIENDA LA FABRICA - SAN JOAQUIN";
  }
  if (lower.includes('vespucio')) {
    return "B2B TIENDA VESPUCIO - CONCHALI";
  }
  if (lower.includes('maipu') || lower.includes('maipú')) return "B2B TIENDA MAIPU - MAIPÚ";
  if (lower.includes('antofagasta')) return "Antofagasta";
  if (lower.includes('concepcion') || lower.includes('concepción')) return "Concepción";
  if (lower.includes('iquique')) return "Iquique";
  if (lower.includes('serena')) return "La Serena";
  if (lower.includes('pucon') || lower.includes('pucón')) return "Pucón";
  if (lower.includes('temuco')) return "Temuco";
  if (lower.includes('argentina')) return "Argentina";
  if (lower.includes('uruguay')) return "Uruguay";

  // Si no calza con patrones específicos, limpiar caracteres no deseados como '?'
  return clean.replace(/\?/g, '').trim();
}
